(function () {
    'use strict';

    let component = {
        transclude: true,
        templateUrl:
            'app/js/components/contract/change-date-time-picker-component/change-date-time-picker.html' + itero.linkVersion,
        controller: controller,
        controllerAs: "vmCDTP",
        bindings: {
            changeDate: '=',
            oldContract: '=',
            oldContractPeriodEnd: '<',
            ngRequired: '<',
            presetName: '='
        }
    };

    iteroComponents.component('changeDateTimePicker', component);

    controller.$inject = ['Contract', 'PUtill'];

    function controller(Contract, PUtill) {
        let ctrl = this;
       
        ctrl.getNow = function () {
            return new Date();
        }
        
        ctrl.setChangeDateNow = function () {
            ctrl.presetName = 'Now';
            ctrl.changeDate = null;
            ctrl.isNowSelected = true;
        }

        ctrl.setChangeDate = function (newDate, presetName) {
            ctrl.presetName = presetName;
            ctrl.isNowSelected = false;
            ctrl.changeDate = newDate ? new Date(newDate) : null;
        }

        ctrl.getDateToTimeAdjusted = function (date) {
            return Contract.getDateToPhaseStartTimeAdjusted(ctrl.oldContract, date);
        };

        ctrl.dateIsInFuture = function (dateStr) {
            return moment(dateStr).isAfter(moment(new Date));
        };
        
        ctrl.$onInit = function () {
            ctrl.changeDate = PUtill.convertToDateIfString(ctrl.changeDate);
        }

        ctrl.isNowSelected = false;
        ctrl.presetName = 'Preset Date';
    }
})();
